import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Evoluções gerais do paciente, com cache de leitura offline (via useCachedQuery).
export function useGeneralEvolutions(patientId) {
  const url = patientId ? `/paciente/evolucao/${patientId}` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    evolutions: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
